import { useEffect } from "react";

export function useOutside(
  ref: any,
  cb: (e: any) => void,
  excludeRefs: any[] = []
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target;
      // If the clicked node was removed from the DOM by the re-render its own
      // click triggered (e.g. toggling a checkbox unmounts the checkmark
      // element), `contains()` can no longer find it and would wrongly report
      // an outside click. A detached target is never a genuine outside click.
      if (target instanceof Node && !target.isConnected) {
        return;
      }
      let isOutside = true;
      if (ref.current && ref.current.contains(event.target)) {
        isOutside = false;
      }
      excludeRefs.forEach((excludeRef) => {
        if (
          excludeRef.current &&
          excludeRef.current.contains(event.target as Node)
        ) {
          isOutside = false;
        }
      });

      if (isOutside) {
        cb(event.target);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref, excludeRefs]);
}
